module.exports = __webpack_public_path__ + "img/25b1d15.jpg";